<template>
    <NuxtLink :to="productLink" @click="handleProductClick" @click.prevent="isDisabled && $event.preventDefault()"
        :class="`${isDisabled ? 'pointer-events-none cursor-not-allowed' : ''}`">
        <div  v-if="item"
        :data-product-id="item?.id || null"
        :class="`product__card__hover h-full relative ease-linear p-1.5 rounded-[0.625rem] duration-[0.15s] transition-[box-shadow,border-color] product_item min-w-[100px] w-full border hover:border-secondary/25 active:border-secondary/30 border-[#E9E9E9] bg-white ${cardBorders}`">
        <!-- h-[10rem] sm:h-[11rem] md:h-[11.563rem] lg:h-[11.8rem] -->
       
             <!-- veritifed flag -->
      <span v-if="isVerified"
        class="absolute z-[1] top-[-14px] rtl:left-[-10px] rtl:right-auto left-auto right-[-10px] text-[0.813rem] font-bold rtl:rounded-[5px_0px] rounded-[0px_5px]">
        <img src="@/assets/icons/verify_white.svg" class="w-[25px] h-[25px]" alt :width="26" :height="26" />
      </span>
        <div class="relative h-auto min-w-[11.593rem] lg:min-w-[11.765rem] cursor-pointer rounded-[0.438rem] overflow-hidden">
                            <!-- visual info -->
                <div class="relative cursor-pointer max-h-[14rem]">
                    <!-- product image -->
                    <div class="z-0 product__image__container w-full"
                        :title="item && item[finalizedNameKey] ? trimText(item[finalizedNameKey], 100) : ''">
                        <div class="product__thumbnail p-[0.3rem] md:p-[0.4rem] lg:p-[0.4.5rem] xl:p-[0.4.7rem]">
                            <img @error="onImageError"
                                class="w-full max-h-[13.375rem] min-h-[12.9rem] h-full block object-contain object-center rounded-[0.438rem] xl:rounded-[0.46rem]"
                                :src="item.image || placeholderImg" alt="" loading="lazy" width="148px" height="155px"
                                draggable="false" />
                        </div>
                    </div>
                    <!-- offer has ended type -->
                    <template v-if="offerRemainingTimeId == 4">
                        <div :class="`${offerRemainingTimeId == 4 ? `before:bg-[#0a0a0acf]` : ''} before:content-[''] before:absolute before:inset-0 before:h-[100%] before:z-[-1] z-[0] absolute inset-0 font-bold text-[0.75rem] md:text-[0.79rem] text-[#FF1F00] grid place-content-center`.trim()">
                            <strong>{{ $t('general.offer_ended') }}</strong>
                        </div>
                    </template>
                    <!-- other types -->
                    <template v-else>
                    <!-- product rating -->
                        <span
                            v-if="(typeof item.ratings_avg === 'string' || typeof item.ratings_avg === 'number') && parseInt(item.ratings_avg) > 0"
                            class="gap-1.5 w-max pr-1.5 pl-2.5 rtl:pl-1.5 font-bold rtl:pr-2.5 py-0.5 absolute bottom-3 rtl:right-2.5 rtl:left-auto right-auto left-2.5 bg-white text-black text-[0.775rem] sm:text-[0.795rem] lg:text-[0.855rem] 3xl:text-[0.875rem] flex items-center rounded-[1.563rem]">
                            <span>{{ arabizeNumbers(Number(item.ratings_avg).toLocaleString()) }}</span>
                            <img :src="starIcon" alt="" width="20" height="20" class="w-[1.25rem] h-[1.25rem] object-contain" />
                        </span>
                        <!-- sale discount percentage - top -->
                        <div
                            class="absolute rotate-[45deg] rtl:rotate-[-45deg] top-0.5 md:top-1 rtl:left-[-2.4rem] rtl:right-auto left-auto right-[-2.1rem]">
                            <strong
                                :class="`${productTypeId === 'retail' ? 'rtl:pl-[2.5rem] rtl:pr-[3rem] ltr:pr-[2.5rem] ltr:pl-[3rem]':'px-[1rem] ltr:pr-[0rem] rtl:px-[2rem] '} block text-[0.9rem] bg-primary text-white py-[0.1rem] text-center`">
                                {{ discountPercentage }}
                            </strong>
                            <span v-if="productTypeId !== 'retail'" class="block text-[0.688rem] bg-[#E5E5E5] text-primary py-[0.1rem] px-[2.5rem] ltr:pr-[2rem] rtl:px-[3rem]">
                                {{ productType }}
                            </span>
                        </div>
                        <!-- offer remaning time label - top -->
                        <div class="absolute top-2 rtl:right-2.5 rtl:left-auto right-auto left-2.5">
                            <span
                                :class="`${offerRemainingTimeId == 2 ? 'bg-[#F9BF60]' : 'bg-primary'} w-max ellipsis-1 gap-1.5 pr-2 pl-2.5 rtl:pl-2 rtl:pr-2.5 py-1.5 text-white text-center font-bold text-[0.75rem] md:text-[0.79rem] flex items-center rounded-[0.438rem]`.trim()">
                                <strong class="w-max mx-auto">{{ countdown }}</strong>
                            </span>
                        </div>
                    </template>
                </div>

                <!-- title & price -->
                <div class="min-h-[3.70rem] px-2">
                    <div class="mb-0 text-black">
                        <!-- title -->
                        <strong v-if="item[finalizedNameKey]" :title="item[finalizedNameKey]"
                            class="product-title font-[600] text-[#515151] text-[0.8rem] md:text-[0.9rem] lg:text-[0.94rem] 3xl:text-[1.1rem] ellipsis-x1">{{
                            item[finalizedNameKey] }}</strong>
                    </div>
                        <!-- Description according to the product type -->
                        <DescriptionPart
                            :item="item"
                            cardType="exclusive_offer"
                        />
                </div>
        </div>

        </div>
    </NuxtLink>
</template>

<script>
import crownIcon from "@/assets/images/crown.svg";
import starIcon from "@/assets/icons/star.svg";
import favedIcon from "@/assets/images/heart-faved.svg";
import unfavedIcon from "@/assets/images/heart-unfaved.svg";
import placeholderImg from "@/assets/images/placeholder(doNotRemove).jpg";
import DescriptionPart from "./DescriptionPart.vue";
import { FavoriteBtn } from "@/components";
import VerifiedIcon from "@/assets/shared/icons/verified.vue";
import viewsIcon from "@/assets/icons/views.svg";
import { buildProductLink, trimText, arabizeNumbers, roundWithHalf, onImageError, buildStoreLink } from "@/helpers";

export default {
    setup() {
        const usedCookieLanguage = useCookie('localStorageCopy')?.value?.language || 'ar';
        const countdown = ref('');  // Add reactive ref for countdown

        return {
            usedCookieLanguage,
            timer: 0,
            countdown
        }
    },
    data() {
        return {
            placeholderImg,
            viewsIcon,
            crownIcon,
            starIcon,
            favedIcon,
            unfavedIcon,
            isFavoriting: false
        };
    },
    props: {
        item: {
            type: Object,
            default: () => ({}),
            required: true
        },
        disableHoverEffect: {
            type: Boolean,
            default: false,
            required: false
        },
        disableVisitingStore: {
            type: Boolean,
            default: false,
            required: false
        },
    },

    components: {
        FavoriteBtn,
        VerifiedIcon,
        DescriptionPart
    },
    computed: {
        isVerified(){
      return !!this.item?.store_verified;
    },
    cardBorders(){
      return this.isAd ? 'border-[#F8B84E] border-[2px] overflow-hidden' : this.isVerified ? 'border-primary border-[2px]'  : 'overflow-hidden hover:border-secondary/25 active:border-secondary/30 border-[#E9E9E9]';
    },
        finalizedNameKey() {
            return this.nameKey || `name_${this.usedCookieLanguage}`;
        },
        finalizedDescriptionKey() {
            return this.descriptionKey || `description_${this.usedCookieLanguage}`;
        },
        productLink() {
            if (!this.item || !this.item.id) {
                return '#';
            }
            return buildProductLink(this.item);
        },
        storeLink() {
            const storeInfo = this.item?.store;
            return buildStoreLink(storeInfo?.username);
        },
        productTypeId(){
            return this.item?.product_type;
        },
        productType(){
            switch(this.productTypeId){
                case "wholesale":
                    return this.$t('general.wholesale');
                case "retail":
                    return this.$t('general.retail');
                case "offer":
                    return this.$t('general.offer_noun');
                default:
                    return "";
            }
        },
        discountPercentage(){
            return arabizeNumbers(this.$t('general.percentage_label', {percentage: Math.round(this.item?.discount)}));
        },
        offerRemaningTimeType(){
            return this.item?.label?.[this.anyKey('label')];
        },
        offerRemainingTimeId(){
            return this.item?.label?.id;
        },
        isDisabled(){
            return false ;
        },
    },
    methods: {
        arabizeNumbers,
        trimText,
        roundWithHalf,
        onImageError,
        updateCountdown() {
            if (!this.item?.end_date) {
                this.countdown = this.offerRemaningTimeType;
                return;
            }

            const now = Date.now();
            const remainingTime = new Date(this.item.end_date);
            const timeDiff = remainingTime - now;

            if (timeDiff <= 0) {
                clearInterval(this.timer);
                this.countdown = 0;
                return;
            }

            // Calculate all time units
            const months = Math.floor(timeDiff / (1000 * 60 * 60 * 24 * 30));
            const weeks = Math.floor((timeDiff % (1000 * 60 * 60 * 24 * 30)) / (1000 * 60 * 60 * 24 * 7));
            const days = Math.floor((timeDiff % (1000 * 60 * 60 * 24 * 7)) / (1000 * 60 * 60 * 24));
            const hours = Math.floor((timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);

            // Create array of non-zero time units
            const timeUnits = [
                { value: months, label: this.usedCookieLanguage === 'ar' ? 'ش' : 'M' },
                { value: weeks, label: this.usedCookieLanguage === 'ar' ? 'أ' : 'w' },
                { value: days, label: this.usedCookieLanguage === 'ar' ? 'ي' : 'd' },
                { value: hours, label: this.usedCookieLanguage === 'ar' ? 'س' : 'h' },
                { value: minutes, label: this.usedCookieLanguage === 'ar' ? 'د' : 'm' },
                { value: seconds, label: this.usedCookieLanguage === 'ar' ? 'ث' : 's' }
            ].filter(unit => unit.value > 0);

            // Take the first 3 significant time units
            const unitsToShow = timeUnits.slice(0, 3);

            // Format the countdown display
            let timeString = '';
            unitsToShow.reverse().forEach((unit, index) => {
                timeString += arabizeNumbers(unit.value) + unit.label + ' ';
            });

            this.countdown = timeString.trim();
        },
        startTimer() {
            this.updateCountdown(); // Initial update
            if (this.timer) {
                clearInterval(this.timer);
            }
            this.timer = setInterval(() => {
                this.updateCountdown();
            }, 1000);
        },
        handleProductClick() {
            // Emit event to parent to save product card position for scroll restoration
            if (this.item && this.item.id) {
                this.$emit('saveProductCardPosition', this.item.id);
            }
            
            // Legacy: Also save scroll position for backward compatibility
            if (process.client && window.scrollY !== undefined) {
                const scrollPosition = window.scrollY;
                const storeUsername = this.$route?.params?.username;
                
                if (storeUsername) {
                    // Save scroll position with store identifier
                    sessionStorage.setItem(`scrollPosition_${storeUsername}`, scrollPosition.toString());
                }
            }
        }
    },
    mounted() {
        this.startTimer();
    },
    beforeUnmount() {
        if (this.timer) {
            clearInterval(this.timer);
        }
    }
};
</script>

<style lang="scss" scoped>
// Todo: remove the css code and only depend on Tailwind classes
.product__image__container {
    display: inline-block;

    .product__thumbnail {
        margin-left: auto;
        margin-right: auto;
        display: block;
        overflow: hidden;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;

        img {
            background: var(--light-gray);
        }
    }

    position: relative;

    &::before {
        display: block;
        content: "";
        width: 100%;

        min-height: 13.375rem;
        padding: 41%;

        @media (min-width: 1318px) {
            max-width: 16.313rem;
        }

        @media (max-width: 581px) {
            min-height: 12.688rem;
        }

        @media (max-width: 418px) {
            min-height: 11.779rem;
        }
    }
}
</style>